import * as React from 'react'

import { cn } from '@/lib/utils'

type CheckboxGroupProps = React.ComponentProps<'fieldset'> & {
  legend?: React.ReactNode
  description?: React.ReactNode
  orientation?: 'vertical' | 'horizontal'
}

function CheckboxGroup({
  className,
  legend,
  description,
  orientation = 'vertical',
  children,
  ...props
}: CheckboxGroupProps) {
  return (
    <fieldset
      data-slot='checkbox-group'
      data-orientation={orientation}
      className={cn('flex flex-col gap-3', className)}
      {...props}
    >
      {(legend || description) && (
        <div className='flex flex-col gap-1'>
          {legend && (
            <legend
              data-slot='checkbox-group-legend'
              className='text-base leading-none font-medium'
            >
              {legend}
            </legend>
          )}
          {description && (
            <span
              data-slot='checkbox-group-description'
              className='text-muted-foreground text-sm'
            >
              {description}
            </span>
          )}
        </div>
      )}
      <div
        className={cn(
          'flex gap-3',
          orientation === 'vertical' ? 'flex-col' : 'flex-row flex-wrap'
        )}
      >
        {children}
      </div>
    </fieldset>
  )
}

export { CheckboxGroup }
